<template>
  <div class="col-md-12 footer mt-5 pt-4" v-if="this.$store.getters.isLoggedIn">
    <p>© {{year}} S. Martinelli & Company <br class="mobile"> Image Library – All Rights Reserved.</p>
  </div>
</template>

<script>
export default{
  name: 'Footer',
  data () {
    return {
      year: new Date().getFullYear()
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue